import BaseApiService from './BaseApiService'
import type { Workspace } from '../types'

class WorkspacesApiService extends BaseApiService {
  ensure(): Promise<Workspace[]> {
    // Silent: AppStateProvider calls this on every page, signed in or not. A non-silent 401 bounced
    // signed-out visitors on public pages (invite links, password reset) to /login.
    return this.postSilent<Workspace[]>('/v1/workspaces/ensure')
  }

  list(): Promise<Workspace[]> {
    return this.post<Workspace[]>('/v1/workspaces/list')
  }


}
export const workspacesApiService = new WorkspacesApiService()
